import { Action } from '@ngrx/store';
import { IDownloadReportRequestObject, IRunReportResponseObject } from 'src/app/models/reports';

export enum ReportsActionTypes {
  RUN_REPORT = 'RUN_REPORT',
  DOWNLOAD_REPORT = 'DOWNALOAD_REPORT',
  RUN_REPORT_SUCCESS = 'RUN_REPORT_SUCCESS',
  CREATE_REPORT_REQUEST_SUCCESS = 'CREATE_REPORT_REQUEST_SUCCESS',
  RUN_REPORT_DATA_ERROR = 'RUN_REPORT_DATA_ERROR',
  RETRIEVE_DOCUMENTS_LIST = 'RETRIEVE_DOCUMENTS_LIST',
  RETRIEVE_DOCUMENT = 'RETRIEVE_DOCUMENT',
  WRITE_PDF_FROM_BLOB = 'WRITE_PDF_FROM_BLOB',
  WRITE_PDF_FROM_DOCUMENT = 'WRITE_PDF_FROM_DOCUMENT'
}

export class DownloadReport implements Action {
  readonly type = ReportsActionTypes.DOWNLOAD_REPORT;
  constructor(public payload: IDownloadReportRequestObject) { }
}

export class RetrieveDocumentsList implements Action {
  readonly type = ReportsActionTypes.RETRIEVE_DOCUMENTS_LIST;
  constructor( public payload: number) {}
}
export class RetrieveDocument implements Action {
  readonly type = ReportsActionTypes.RETRIEVE_DOCUMENT;
  constructor( public payload: any) {}
}
export class CreateReportRequestSuccess implements Action {
  readonly type = ReportsActionTypes.CREATE_REPORT_REQUEST_SUCCESS;
  constructor( public payload: string) {}
}
export class RunReportSuccess implements Action {
  readonly type = ReportsActionTypes.RUN_REPORT_SUCCESS;
  constructor(public payload: string) { }
}
export class RunReportDataError implements Action {
  readonly type = ReportsActionTypes.RUN_REPORT_DATA_ERROR;
  constructor( public payload: string) {}
}
export class WritePDFFromBlob implements Action {
  readonly type = ReportsActionTypes.WRITE_PDF_FROM_BLOB;
  constructor( public payload: any) {}
}
export class WritePDFFromDocument implements Action {
  readonly type = ReportsActionTypes.WRITE_PDF_FROM_DOCUMENT;
  constructor( public payload: IRunReportResponseObject) {}
}

export type ReportsActions = RetrieveDocumentsList | RetrieveDocument | WritePDFFromBlob | WritePDFFromDocument | RunReportSuccess | CreateReportRequestSuccess | RunReportDataError;
